import { EntityInput, LinkProps } from "helpers/url";
import {
  ROUTE_TEAM,
  ROUTE_TEAM_AUTHOR,
  ROUTE_TEAM_DOCTOR,
  ROUTE_TEAM_STAFF,
} from "constants/routes";

export function teamHref(entity: EntityInput = {}): LinkProps["href"] {
  const { author = "", doctor = "", staff = "" } = entity;
  if (author) {
    return {
      pathname: ROUTE_TEAM_AUTHOR,
      query: {
        id: author,
      },
    };
  }

  if (doctor) {
    return {
      pathname: ROUTE_TEAM_DOCTOR,
      query: {
        id: doctor,
      },
    };
  }

  if (staff) {
    return {
      pathname: ROUTE_TEAM_STAFF,
      query: {
        id: staff,
      },
    };
  }

  return {
    pathname: ROUTE_TEAM,
    query: {},
  };
}

export function teamAs(entity: EntityInput = {}): LinkProps["as"] {
  const { author = "", doctor = "", staff = "" } = entity;

  if (author) {
    return `/team/author/${author}/`;
  }

  if (doctor) {
    return `/team/doctor/${doctor}/`;
  }

  if (staff) {
    return `/team/staff/${staff}/`;
  }

  return `/team/`;
}
